import React from 'react';
import { connect } from 'react-redux';
import ColumnWidth from './ColumnWidth';
import Komentar from './Komentar';

const DisplayObavestenja = (props) => {

  let obavestenja = [];
  if (Array.isArray(props.obavestenja)) {
    obavestenja = props.obavestenja;
  }


  let jsxObavestenja = null;
  jsxObavestenja = obavestenja.map((o, index) => {
    return (
      <div key={index} className="msg warning-msg">
        <span>{index + 1}. {o.title}</span>
      </div>
    )
  });

  return (
    <>
      <ColumnWidth w={480}>
        <div className="card">
          <div className="card-header">
            <span>Obaveštenja</span>
          </div>
          <div className="card-body">
            {jsxObavestenja}
          </div>
        </div>
        <Komentar>Ova obaveštenja treba proširiti za tipove obaveštenja i još pratećih elemenata. Sve paralalno izmeniti i ovde i u DisplayErrorMessages i u ToastBig i u akcijama za kreiranje obaveštenja</Komentar>
      </ColumnWidth>
    </>
  );
};


export default DisplayObavestenja;